import { useListUser } from "stores/hooks/list-user";
import {
  StyledBaseStatus,
  StyledFailure,
  StyledStatus,
  StyledSuccess,
} from "./base-status.styles";
import { timestamp } from "lib/date";
import { faCheck, faXmark } from "components/icon-library";
import { useTranslate } from "stores/hooks/translation";

const BaseStatus = () => {
  const listUser = useListUser();
  const translate = useTranslate();

  if (!listUser) {
    return null;
  }

  const {
    status,
    draft_at,
    invited_at,
    progress_at,
    submitted_at,
    approved_at,
  } = listUser;

  const renderTimestamp = (at?: string) => {
    if (!at) {
      return null;
    }
    return `[${timestamp(at)}]`;
  };

  const renderIcon = (checked: boolean) => {
    if (checked) {
      return <StyledSuccess icon={faCheck} />;
    }
    return <StyledFailure icon={faXmark} />;
  };

  const renderDraft = () => {
    return (
      <StyledStatus>
        {renderIcon(
          status === "draft" ||
            status === "invited" ||
            status === "progress" ||
            status === "submitted" ||
            status === "approved",
        )}
        {translate("user_status_draft")} {renderTimestamp(draft_at)}
      </StyledStatus>
    );
  };

  const renderInvited = () => {
    return (
      <StyledStatus>
        {renderIcon(
          status === "invited" ||
            status === "progress" ||
            status === "submitted" ||
            status === "approved",
        )}
        {translate("user_status_invited")} {renderTimestamp(invited_at)}
      </StyledStatus>
    );
  };

  const renderProgress = () => {
    return (
      <StyledStatus>
        {renderIcon(
          status === "progress" ||
            status === "submitted" ||
            status === "approved",
        )}
        {translate("user_status_progress")} {renderTimestamp(progress_at)}
      </StyledStatus>
    );
  };

  const renderSubmitted = () => {
    return (
      <StyledStatus>
        {renderIcon(status === "submitted" || status === "approved")}
        {translate("user_status_submitted")} {renderTimestamp(submitted_at)}
      </StyledStatus>
    );
  };

  const renderApproved = () => {
    return (
      <StyledStatus>
        {renderIcon(status === "approved")}
        {translate("user_status_approved")} {renderTimestamp(approved_at)}
      </StyledStatus>
    );
  };

  return (
    <StyledBaseStatus>
      {renderDraft()}
      {renderInvited()}
      {renderProgress()}
      {renderSubmitted()}
      {renderApproved()}
    </StyledBaseStatus>
  );
};

export default BaseStatus;
